import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import xhr from 'xhr';
import pify from 'pify';
import FormContainer from '@starbucks-web/pattern-library/lib/components/form-container/';
import { push as pushAction } from 'redux-first-history';

import { validateEmail } from 'shared/app/utils/validators';

import FormWithMessaging from 'shared/app/components/form-with-messaging';
import ContentColumn from '@starbucks-web/pattern-library/lib/components/content-column';
import ForgotPasswordColumn from '../forgot-password-column';
import { FormattedMessage } from 'react-intl';

const promisedXhr = pify(xhr);

const fields = {
  emailAddress: {
    validator: validateEmail,
  },
  userName: {
    required: false,
  },
};

export class ForgotPassword extends Component {
  constructor() {
    super();
  }

  handleSubmit({ emailAddress, userName }) {
    const formData = {
      emailAddress,
      userName: userName || emailAddress,
    };

    this.postForm(formData);
    this.props.push('/account/forgot-password/success');
  }

  postForm(data) {
    return promisedXhr({
      url: `/apiproxy/v1/account/forgot-password`,
      json: data,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
  }

  render() {
    const submitHandler = this.props.onSubmit || this.handleSubmit.bind(this);

    return (
      <ContentColumn className="py6 lg-py9 mb9" size="sm">
        <p className="py3 color-textBlackSoft">
          <FormattedMessage
            defaultMessage="Just need to confirm your email to send you instructions to reset your password."
            // eslint-disable-next-line max-len
            description="Description of password reset email process"
            id="accountSignin.forgotPasswordColumn.enterEmailText"
          />
        </p>
        <FormContainer
          fields={fields}
          focusOnSubmitError
          onSubmit={submitHandler}
        >
          <FormWithMessaging>
            <ForgotPasswordColumn />
          </FormWithMessaging>
        </FormContainer>
      </ContentColumn>
    );
  }
}

ForgotPassword.propTypes = {
  onSubmit: PropTypes.func,
};

export default connect(null, { push: pushAction })(ForgotPassword);
